namespace TabAurous {
    export interface CommonMFGRequest extends Serenity.ListRequest {
        ProductId?: number;
        AttributeId?: number;
        VoucherTypeId?: number;
        SKU?: string;
        Line_No?: number;
        LotNo?: string;
        TransId?: number;
        TransItemId?: number;
        RefTransId?: number;
        RefTransItemId?: number;
        BagNo?: string;
        DepartmentId?: number;
        DepartmentIds?: number[];
        CompanyId?: number;
        FinancialYearId?: number;
        SplitEmptyBag?: boolean;
        SplitSingleItem?: boolean;
        AllowSplitParts?: boolean;
    }
}
